import React from 'react';
import DisplayEmail from './email';
import DisplayTask from './task';
import DisplaySms from './sms';


const tmplMap = {
    email: DisplayEmail,
    sms: DisplaySms,
    call: DisplayTask,
    task: DisplayTask
    // ...add more mappings as needed
  };
  
export default function DisplayTemplate( {sid, tid, close, objType, tmplType } ) {
    const TemplateComponent = tmplMap[tmplType];
  
    if ( !TemplateComponent ) {
      return <div className="text-muted">No template available for this type.</div>;
    }
  
    return <TemplateComponent sid={sid} tid={tid} close={close} objType={objType} />;
}